// extracted by mini-css-extract-plugin
export default {"max_w_48":"KYCDetailsStyle_max_w_48__WZwdV","status_processing":"KYCDetailsStyle_status_processing__lzDOI","status_resubmitted":"KYCDetailsStyle_status_resubmitted__waPwE"};